<template>
    <div class="content-builder">
        <div class="form-group">
            <QuillEditor :toolbar="toolbarOpts" :modules="editorModules" theme="snow" :contentType="'html'" v-model:content="content.text"/>
        </div>
        <div class="form-group">
            <div class="actions">
                <div class="action-item">
                    <button class="btn btn-default" type="button" :disabled="limitReached" v-show="!limitReached"
                            @click="addOutcome"><i class="fa fa-plus"></i> Add Outcome
                    </button>
                    <small class="text-muted" v-show="limitReached">This page is limited to a total of {{ limit }}
                        possible outcomes.</small>
                </div>
                <div class="action-item">
                    <input id="show-0-val-outcomes" type="checkbox" v-model="content.showOutcomeOfZero">
                    <label for="show-0-val-outcomes" class="control-label">Show outcomes with value of 0</label>
                </div>
            </div>
            <div class="content-list">
                <div v-for="(outcome, index) in content.outcomes" :key="index" v-cloak class="card content-list-item">
                    <div class="card-body">
                        <div class="form-group">
                            <label for="text" class="control-label">Outcome Text</label>
                            <textarea class="form-control" v-model="outcome.text"></textarea>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-4">
                                <label for="flow" class="control-label">Outcome Identifier</label>
                                <input type="text" class="form-control" v-model="outcome.id"
                                       :placeholder="'event-' + (index + 1)">
                            </div>
                            <div class="col-sm-8">
                                <label for="outcome-image" class="control-label">Outcome Image</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <a :data-input="'outcome-image-' + index" class="btn btn-primary text-white"
                                           data-lfm="image">
                                            <i class="fa fa-image-o"></i> Choose
                                        </a>
                                    </div>
                                    <input :id="'outcome-image-' + index" type="text" class="form-control"
                                           v-model.lazy="outcome.image">
                                </div>
                            </div>
                        </div>
                        <div class="form-group card-metrics">
                            <label for="metrics" class="control-label">Meter Effects</label>
                            <div class="row">
                                <div v-for="meter in outcome.meters" :key="meter.id" class="col-sm">
                                    <span :class="['badge', 'badge-primary', meter.id]">{{ meter.id }}</span>
                                    <input :id="meter.id" type="number" class="form-control" v-model="meter.value">
                                </div>
                                <div class="col-sm offset-sm-3">
                                    <label class="control-label">&nbsp;</label>
                                    <button type="button" class="btn btn-danger btn-block"
                                            @click="remove(outcome, index)">Remove
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {defaultMeters} from '../../../common/metrics'
    import layoutMixin from '../../mixins/layout'
    import limitedMixin from '../../mixins/limited'
    import { EDITOR_CONFIG_BUTTONS_FULL } from '../../../common/constants'
    import { QuillEditor } from '@vueup/vue-quill'
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    export default {
        components: {
          QuillEditor
        },
        mixins: [layoutMixin, limitedMixin],
        data() {
            const content = _.cloneDeep(this.source)
            const filled = _.defaults(content, {
                outcomes: [{}, {}]
            })

            // pre-fill with default data
            filled.outcomes.forEach((outcome) => {
                if (!outcome.meters || !outcome.meters.length) {
                    outcome.meters = defaultMeters()
                }
            })

            if (!_.get(content, 'showOutcomeOfZero')) {
              content.showOutcomeOfZero = false;
            }

            return {
                content: filled,
                limit: 6,
                toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL
            }
        },
        computed: {
            limitedItem() {
                return this.content.outcomes
            }
        },
        methods: {
            setContent() {
                console.log('Consequence::setContent')
            },
            getValue() {
                 _.each(this.content.outcomes, (outcome, key) => {
                    this.content.outcomes[key].image = $("#outcome-image-" + key).val()
                })
                return this.content
            },
            remove(item, index) {
                this.content.outcomes.splice(index, 1)
            },
            addOutcome() {
                this.content.outcomes.unshift({
                    meters: defaultMeters()
                })

                this.$nextTick(() => {
                    $(this.$el).find('[data-lfm]').filemanager('image', {prefix: '/filemanager'})
                })
            }
        }
    }
</script>
